import React from 'react'
import ReactPopperDropdown from 'react-popper-dropdown'
import './styles.scss'

const Dropdown = ({ options = [], onChange = () => {}, disabled = false, ...props }) => {
  return (
    <div className="inputs-dropdown-container">
      <ReactPopperDropdown
        choices={options?.map(({ value, label }) => ({ id: value, label }))}
        onValueChange={({ id, label }) => onChange({ value: id, label })}
        enabled={!disabled}
        filterable={false}
        enableReset={false}
        {...props}
      />
    </div>
  )
}

export default Dropdown
